import React from 'react';

import { Button, Layout, Logo } from 'ds';
import { actions } from 'store/ServicesRequest';
import { useAppDispatch } from 'store/hooks';

import { PUBLIC_SERVICES_REQUEST_HEADER_HEIGHT_MOBILE } from './constants';

interface Props {}

const StepMobileHeader: React.FC<Props> = () => {
  const dispatch = useAppDispatch();

  return (
    <Layout justify="space-between" height={PUBLIC_SERVICES_REQUEST_HEADER_HEIGHT_MOBILE} align="center">
      <Logo color="blue-500" size="sm" />
      <Button onClick={() => dispatch(actions.setExitModalIsVisible(true))} size="xs" type="secondary" text="Exit" />
    </Layout>
  );
};

export default StepMobileHeader;
